import { emailRegex } from 'constants/regex';

/**
 * Normalizes an email for comparison and submission: trims surrounding
 * whitespace and lower-cases it so confirmation matching ignores letter casing.
 */
export const normalizeEmail = input => String(input ?? '').trim().toLowerCase();
const isAsciiOnly = value => [...value].every(char => char.charCodeAt(0) <= 127);
const isValidEmail = input => {
  const value = String(input ?? '').trim();
  if (value.length === 0) return false;

  // Reject any internal whitespace, e.g. "test.user@gmail .com".
  if (/\s/.test(value)) return false;

  // Reject Unicode substitutes such as the fullwidth at-sign (U+FF20) and
  // other non-ASCII look-alikes by allowing ASCII characters only.
  if (!isAsciiOnly(value)) return false;
  return emailRegex.test(value.toLowerCase());
};
export default isValidEmail;